import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _GradingSidebarItem;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import t from '@instructure/quiz-i18n/es/format-message';
import { SidebarItem as CommonSidebarItem } from '@instructure/quiz-core';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var GradingSidebarItem = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_GradingSidebarItem = /*#__PURE__*/function (_Component) {
  function GradingSidebarItem() {
    _classCallCheck(this, GradingSidebarItem);
    return _callSuper(this, GradingSidebarItem, arguments);
  }
  _inherits(GradingSidebarItem, _Component);
  return _createClass(GradingSidebarItem, [{
    key: "renderGradedMarkings",
    value: function renderGradedMarkings() {
      return jsx(ScreenReaderContent, null, t('Question at position {position} is graded', {
        position: this.props.position
      }));
    }
  }, {
    key: "renderNeedsGradingMarkings",
    value: function renderNeedsGradingMarkings() {
      return jsx("div", {
        className: "needsGradingDot",
        css: this.props.styles.needsGradingDot
      }, jsx(ScreenReaderContent, null, t('Question at position {position} needs grading', {
        position: this.props.position
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.itemWrapper
      }, this.props.isGraded ? this.renderGradedMarkings() : this.renderNeedsGradingMarkings(), jsx(CommonSidebarItem, {
        itemBody: this.props.itemBody,
        itemId: this.props.sessionItemId,
        itemName: this.props.itemName,
        inStimulus: this.props.inStimulus,
        pointsPossible: this.props.pointsPossible,
        position: this.props.position,
        scrollToItem: this.props.scrollToItem(this.props.position),
        sidebarOpen: this.props.sidebarOpen
      }));
    }
  }]);
}(Component), _defineProperty(_GradingSidebarItem, "displayName", 'GradingSidebarItem'), _defineProperty(_GradingSidebarItem, "componentId", "Quizzes".concat(_GradingSidebarItem.displayName)), _defineProperty(_GradingSidebarItem, "propTypes", {
  inStimulus: PropTypes.bool,
  itemBody: PropTypes.string,
  itemName: PropTypes.string.isRequired,
  isGraded: PropTypes.bool.isRequired,
  pointsPossible: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  sessionItemId: PropTypes.string.isRequired,
  scrollToItem: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  styles: PropTypes.object
}), _defineProperty(_GradingSidebarItem, "defaultProps", {
  inStimulus: false,
  itemBody: ''
}), _GradingSidebarItem)) || _class);
export default GradingSidebarItem;